export const CURACAO_SIZE = { width: 87, height: 28 }
